export var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["VIDEO"] = "video";
    MediaType["SVG"] = "svg";
})(MediaType || (MediaType = {}));
export var PopinFormat;
(function (PopinFormat) {
    PopinFormat["BANNER"] = "banner";
    PopinFormat["POPIN"] = "popin";
    PopinFormat["CENTERED"] = "centered";
    PopinFormat["EDGING"] = "edging";
    PopinFormat["OPTIN"] = "optin";
    PopinFormat["OPTIN_CENTERED"] = "optin_centered";
})(PopinFormat || (PopinFormat = {}));
;
